<template>
  <v-footer>
    <div class="footer-bottom">
      <v-container>
        <v-row>
          <v-col cols="12" md="12" class="text-center mt-3 mb-2">
            <a href="/homepage" class="logo-anchor footer-logo"
              ><img style="width: 280px; max-width: 100%; height: auto;" src="/static/footer-logo.png"
            /></a>
          </v-col>
        </v-row>
      </v-container>
      <hr />
      <v-container>
        <v-row class="d-flex justify-content-center">
          <v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
            <!-- Mirrors the header's primary navigation, in the same order,
                 including the "More" menu (Steve, 15 Sep 2026). If a page is
                 added to the header it belongs here too. -->
            <h3 class="footer-sub-title">IMPROVE</h3>
            <div class="footer-links">
              <a href="/solutions">Solutions</a>
              <a href="/features">Platform</a>
              <a href="/course-library">Library</a>
              <a href="/pricing">Pricing</a>
              <a href="/customer-stories">Stories</a>
              <a href="/leadership-plus">Leadership Plus</a>
              <a href="/compare">Compare IMPROVE</a>
              <a href="/why-switch">Why Switch</a>
              <a href="/contact">Contact</a>
              <a href="/faq">FAQs</a>
              <a href="/watch-demo">Watch the 5-minute demo</a>
              <a :href="experienceHref" rel="noopener">Experience IMPROVE</a>
              <a href="/get-started">Buy IMPROVE</a>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
            class="mt-10 black--text center"
          >
            <!-- The header's utility bar. -->
            <h3 class="footer-sub-title">Company</h3>
            <div class="footer-links">
              <a href="/about-us">Our Story</a>
              <a href="/partner-programme">Partners</a>
              <a href="/resources">Resources</a>
              <a :href="loginHref">Login</a>
              <a :href="partnerUrl">Partner Login</a>
            </div>
            <h3 class="footer-sub-title mt-6">Courses</h3>
            <div class="footer-links">
              <a href="/course-library?course=Compliance"
                >Compliance</a
              >
              <a href="/course-library?course=PeopleAndRelationships"
                >People & Relationships</a
              >
              <a href="/course-library?course=ManagementAndLeadershipCourses"
                >Management & Leadership</a
              >
              <a href="/course-library?course=ProjectManagementCourses"
                >Project Management</a
              >
              <a href="/course-library?course=HealthAndSafetyCourses"
                >Health & Safety</a
              >
              <a href="/course-library?course=ITSkillsCourses"
                >IT Skills</a
              >
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
            <h3 class="footer-sub-title">Terms & Policies</h3>
            <div class="footer-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/eula">End user license agreement</a>
              <a href="/usage-policy">Terms of use policy</a>
              <a href="#" @click.prevent="openCookieSettings">Cookie settings</a>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
            <h3 class="footer-sub-title">Contact</h3>
            <div class="footer-links">
              <a
                href="mailto:info@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20..."
                >info@improve.online</a
              >
            </div>
            <h5>IMPROVE PRODUCTIONS LIMITED</h5>
            <span class="footer-item">Space City, Dock</span>
            <span class="footer-item">75 Exploration Drive</span>
            <span class="footer-item">Leicester</span>
            <span class="footer-item">LE4 5NU</span>
            <span class="footer-item">United Kingdom</span>
            <div class="company-social">
              <a
                href="https://www.linkedin.com/company/improveonline"
                target="_blank"
                ><img src="/static/icons/improve-linkedin.png"
              /></a>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <hr />
      <div>
        <v-col cols="12" class="text-center">
          <span class="footer-company-sub-title">
            © {{ currentYear }} IMPROVE PRODUCTIONS LIMITED | Registered Company Number:
            11320233
          </span>
        </v-col>
      </div>
    </div>
  </v-footer>
</template>

<script>
import { eventBus } from "@/utils/eventBus";
import { IMPROVE_CONFIG } from '@/config.js';
import { getExperienceHref, getLoginHref } from '@/config/ctas';

export default {
  name: "Footer",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      partnerUrl: IMPROVE_CONFIG.PARTNER_URL,
    };
  },
  computed: {
    experienceHref() {
      return getExperienceHref();
    },
    // Same resolution as the header: follows the host you are on (staging site
    // to staging app), and honours window.__PRERENDER_HOST__ at build time.
    loginHref() {
      return getLoginHref();
    },
  },
  methods: {
    openCookieSettings() {
      // Reopen the cookie banner so the visitor can review or change their choice.
      eventBus.$emit("open-cookie-banner");
    }
  }
};
</script>

<style>
.footer-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.footer-sub-title {
  font-size: 18px;
  font-weight: bold;
  color: #002458;
  margin-bottom: 15px;
}

.footer-item {
  font-size: 13px;
  color: #333333;
  margin: 0;
  padding: 0;
  display: block;
}

.footer-links a {
  font-size: 13px;
  color: #333333;
  font-weight: normal;
  line-height: 32px;
  display: block;
  text-decoration: none;
}
.company-social {
  margin-top: 10px;
}

.footer-company-sub-title {
  font-size: 11px;
  font-weight: normal;
  color: #333333;
  margin-bottom: 15px;
}

@media (max-width: 1264px) {
  .footer-bottom {
    text-align: center !important;
  }
}
</style>
